const en = {
	предложение: 'offering',
	предложения: 'offerings',
	предложений: 'offerings',
	'Ближайшие предложения': 'Closest offerings',
};

export default en;
